import type {MarginProps} from "@/styles/margin.types";

import theme from "@/styles/theme";
import {css} from "styled-components";

const margins = {
    none: 0,
    x2small:theme.margin.xsmall,
    xsmall: theme.margin.xsmall,
    small: theme.margin.small,
    default: theme.margin.default,
    large: theme.margin.large,
    xlarge: theme.margin.xlarge,
    x2large: theme.margin.x2large
};

export const margin =
    ({
         margin,
         marginVertical,
         marginHorizontal,
         marginTop,
         marginRight,
         marginBottom,
         marginLeft
     }: MarginProps) => {
        return css`
          ${margin && css`margin: ${margins[margin]}px;`}
          ${marginVertical && css`margin: ${margins[marginVertical]}px 0;`}
          ${marginHorizontal && css`margin: 0 ${margins[marginHorizontal]}px;`}
          ${marginTop && css`margin-top: ${margins[marginTop]}px;`}
          ${marginRight && css`margin-right: ${margins[marginRight]}px;`}
          ${marginBottom && css`margin-bottom: ${margins[marginBottom]}px;`}
          ${marginLeft && css`margin-left: ${margins[marginLeft]}px;`}
        `;
    };
